import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field } from 'redux-form';
import renderTextField from '../../components/MaterialUi/renderTextField';
import RFSelectField from '../../components/ReduxFormComps/RFSelectField';
import ContentRowSpace from './common/ContentRowSpace'
import styles from './common/styles';
import Paper from 'material-ui/Paper'
import * as actions from '../../redux/gorgon/actions'
import AddIcon from 'material-ui-icons/Add';
import DeleteIcon from 'material-ui-icons/Delete';
import IconButton from 'material-ui/IconButton';
import Tooltip from 'material-ui/Tooltip';
import Button from 'material-ui/Button'

const CoverageItem=(props)=>{
    const appInfoCoverageRequested=`appInfoCoverageRequested${props.formId}`
    const appInfoCurrentAmtInForce=`appInfoCurrentAmtInForce${props.formId}`
    const appInfoAdditionalAmtReq=`appInfoAdditionalAmtReq${props.formId}`
    const appInfoTotalAmtReq=`appInfoTotalAmtReq${props.formId}`
    return (
        <div className="row">
            <div className='col-sm'>
                <Field
                    name={appInfoCoverageRequested}
                    component={renderTextField}
                    label="Coverage Requested"
                    style={styles.appInfoNameTextFieldStyle}
                />
                <Field
                    name={appInfoCurrentAmtInForce}
                    component={renderTextField}
                    label="Current Amount"
                    style={styles.appInfoAmountTextFieldStyle}
                />
                <Field
                    name={appInfoAdditionalAmtReq}
                    component={renderTextField}
                    label="Additional Amount"
                    style={styles.appInfoAmountTextFieldStyle}
                />
                <Field
                    name={appInfoTotalAmtReq}
                    component={renderTextField}
                    label="Total Amount"
                    style={styles.appInfoAmountTextFieldStyle}
                />
                {props.formId != 1?(
                <Tooltip title="Delete">
                    <IconButton color="primary" onClick={()=>props.deleteItemOnClick(props.formId)}>
                        <DeleteIcon />
                    </IconButton>    
                </Tooltip>
                ):null}
            </div> 
        </div>   
    )
}

const clearCoverageItem=(formId,props)=>{
    const appInfoCoverageRequested=`appInfoCoverageRequested${formId}`
    const appInfoCurrentAmtInForce=`appInfoCurrentAmtInForce${formId}`
    const appInfoAdditionalAmtReq=`appInfoAdditionalAmtReq${formId}`
    const appInfoTotalAmtReq=`appInfoTotalAmtReq${formId}`

    props.changeFieldValue(appInfoCoverageRequested,'')
    props.changeFieldValue(appInfoCurrentAmtInForce,'')
    props.changeFieldValue(appInfoAdditionalAmtReq,'')
    props.changeFieldValue(appInfoTotalAmtReq,'')
}

class DocFormApplication extends React.Component {
    state = {
        update: new Date()
    }

    
    shouldComponentUpdate(nextProps, nextState) {
        if (this.state.update !== nextState.update){
            return true
        }
        return false;
    }

    addNewClick(){
        this.setState({update: new Date()})
        this.props.addAppCoverageLine()
    }

    deleteItemOnClick(formId){
        clearCoverageItem(formId,this.props)
        this.setState({update: new Date()})
        this.props.removeAppCoverageLine(formId);
    }

    render(){
        const { gorgon } = this.props;
        const { formAppCoverages } = gorgon;
        
        return (
            <div>
                <Paper>
                    <div className="container">
                        <div className='row'>
                            <div className='col-sm'>
                                <Field
                                    label="Application Types"
                                    name="appInfoApplicationType"
                                    datas={gorgon.applicationTypes}
                                    component={RFSelectField}
                                    codeField={'code'}
                                    descField={'name'}
                                    customStyle={styles.nameTextFieldStyle}
                                />
                            </div>
                            <div className='col-sm'>
                                <div style={{paddingTop: '15px'}}>
                                    <Tooltip title="Add New">
                                        <Button variant="raised" color="primary" onClick={this.addNewClick.bind(this)}>
                                            Add New
                                           <AddIcon />
                                        </Button>
                                    </Tooltip>
                                </div>
                            </div>    
                        </div>    
                        { formAppCoverages.map((form)=>(
                            <CoverageItem 
                                key={form.formId} formId={form.formId} 
                                deleteItemOnClick={this.deleteItemOnClick.bind(this)}/>
                        ))}
                    </div>
                    <ContentRowSpace />
                </Paper>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        gorgon: state.gorgon
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
      addAppCoverageLine: () => {
         dispatch(actions.addAppCoverageLine())  
      },
      removeAppCoverageLine: (formId) => {
        dispatch(actions.removeAppCoverageLine(formId))  
      }
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(DocFormApplication);


// WEBPACK FOOTER //
// ./src/views/ProjectGorgon/DocFormApplication.js